<template>
  <div class="judgeType">
    <!-- 判断打开页面的手机是安卓还是ios -->
    <wxTipmask v-if="showWxTipMask" />
  </div>
</template>
<script>
import wxTipmask from "./components/wxTipmask.vue";
export default {
  name: "appDownload",
  data() {
    return {
      appDownloadUrl: "",
      showWxTipMask: false
    };
  },
  components: {
    wxTipmask
  },
  mounted() {
    const appType = this.$publicFn.judgeType();
    console.log("#######################", appType);
    if (appType == "android") {
      this.appDownloadUrl =
        "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/android/app-evn_release-release.apk";
    } else if (appType == "isWxAndroid") {
      this.showWxTipMask = true;
      //---
      return;
    } else if (appType == "ios" || appType == "isWxIos") {
      this.appDownloadUrl =
        "https://apps.apple.com/cn/app/%E5%92%9A%E5%92%9A%E7%87%95%E5%8A%A9%E6%89%8B/id1576662411";
    } else {
      return;
    }
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = this.appDownloadUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
</script>
<style scoped>
</style>

